import { delay } from 'bog-arcade-core-ui/helpers';

import { gamePadService } from './GamePadService';
import { gameService } from '../apiServices/GameService';
import { gameAnimations } from './GameAnimationService';
import { spinResponseService } from './SpinResponseService';
import { bigWinService } from './BigWinService';
import { backgroundDrawer } from '../../elementDrawers/background/BackgroundDrawer';
import { ballDrawer } from '../../elementDrawers/balls/BallDrawer';
import { userService } from './UserService';
import { soundService } from './SoundService';

class AutoSpinHelper {
  constructor() {
    bigWinService.setAutoSpinPause(() => autoSpinHelper.pause());
    bigWinService.setAutoSpinResume(() => autoSpinHelper.resume());
  }

  start(event) {
    gamePadService.setAutoSpinActiveState(true);
    gamePadService.setSpinCount(gamePadService.spinCount);
    this._autoSpinChain(event);
  }

  decrementSpinCount() {
    gamePadService.setSpinCount(gamePadService.currentSpinCount - 1);
  }

  end() {
    gamePadService.setSpinCount(0);
    gamePadService.setAutoSpinActiveState(false);
    gamePadService.disableAll();
  }

  resume() {
    gamePadService.setAutoSpinActiveState(true);
    return this._autoSpinChain();
  }

  pause() {
    gamePadService.disableAll();
    gamePadService.setAutoSpinActiveState(false);
  }

  _autoSpinChain(event) {
    const betAmount = gamePadService.quickBet;
    gamePadService.disableAllWhileAutoSpin();
    if (gamePadService.currentSpinCount > 0 && gamePadService.autoSpinActiveState && userService.checkBalance(betAmount)) {
      gameService.spin().then((res) => {
        userService.updateBalance(res.balance, () => userService.minusBalance(betAmount));
        this.decrementSpinCount();
        if (!gamePadService.currentSpinCount) {
          gamePadService.disableAll();
          this.end();
        }
        if (res.odd) {
          soundService.playBreakStone();
          gameAnimations.breakBall().then(() => {
            ballDrawer.application.breakBall().then(() => {
              spinResponseService.setData(res);
            });
          });
          ballDrawer.application.hideBall();
          gameAnimations.breakBallBoom().then(() => {
            if (!gamePadService.currentSpinCount) {
              this.end();
            }
          });
          if (bigWinService.check(res, 1)) {
            bigWinService.start();
          } else {
            backgroundDrawer.application.setWinOdd(res).then(() => {
              delay(() => {
                this._autoSpinChain(event);
              }, 400);
            });
          }
          userService.plusBalance(res.winAmount);
        } else {
          soundService.playCrackStone();
          gameAnimations.crackBall();
          gameAnimations.crackParticles();
          delay(() => {
            ballDrawer.application.crackBall().then(() => {
              if (!gamePadService.currentSpinCount) {
                this.end();
              }
              spinResponseService.setData(res);
              delay(() => {
                this._autoSpinChain(event);
              }, 800);
            });
          }, 300);
        }
      }).catch(() => {
        gamePadService.enableAll();
      });
    } else {
      gamePadService.enableAll();
    }
  }
}

export const autoSpinHelper = new AutoSpinHelper();
